export default __webpack_public_path__ + "static/QuickTaskicon-b022f7d254310704a563ab06f8650cc6.png";